export default class Banner {
  constructor(element) {
    this.element = element;
    this.list = this.element.querySelector(".js-banner-list");   

    this.init();
  }

  init() {
      const bannerWidth = this.list.parentElement.offsetWidth;
    
      while (this.list.scrollWidth < bannerWidth * 2) {
          this.list.innerHTML += this.list.innerHTML;
      }
  }
}
